import { render, staticRenderFns } from "./details salary.vue?vue&type=template&id=4704ccf5"
import script from "./details salary.vue?vue&type=script&lang=js"
export * from "./details salary.vue?vue&type=script&lang=js"
import style0 from "./details salary.vue?vue&type=style&index=0&id=4704ccf5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports